<div class="overlay fade" [class.show]="isOpen">
    <div 
    class="pdf-overlay" 
    *ngIf="isOpen" 
    (click)="$event.target.classList.contains('pdfViewer') ? close() : null">
        <ng-content></ng-content>

        <button class="close" (click)="close()"><i class="las la-times"></i></button>
    </div>
</div>
